import { useCallback, useEffect, useState } from "react";
import ResizeObserver from "resize-observer-polyfill";
export function useElementSize(initialRef) {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = useState(null);
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });
    // Prevent too many rendering using useCallback
    const handleSize = useCallback(() => {
        if (ref) {
            const computedStyle = window.getComputedStyle(ref);
            const paddingX = parseFloat(computedStyle.paddingLeft) +
                parseFloat(computedStyle.paddingRight);
            const paddingY = parseFloat(computedStyle.paddingTop) +
                parseFloat(computedStyle.paddingBottom);
            const result = {
                width: ref.clientWidth - paddingX,
                height: ref.clientHeight - paddingY,
            };
            setSize(result);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref === null || ref === void 0 ? void 0 : ref.clientHeight, ref === null || ref === void 0 ? void 0 : ref.clientWidth]);
    useEffect(() => {
        handleSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        if (ref) {
            const observer = new ResizeObserver(() => handleSize());
            observer.observe(ref);
            return () => {
                observer.disconnect();
            };
        }
    }, [ref, handleSize]);
    return [setRef, size];
}
